import axios from "axios";

const state = () => ({
  errors: null,
  packages: [],
});

const mutations = {
  SET_ERRORS(state, errors) {
    state.errors = errors;
  },
  CLEAR_ERRORS(state) {
    state.errors = null;
  },
  SET_PACKAGES(state, data) {
    state.packages = data;
  },
};

const getters = {
  getPackagesList: (state) => {
    return state.packages;
  },
};

const actions = {
  async fetchPackages({ commit }) {
    commit("CLEAR_ERRORS");
    const url = process.env.VUE_APP_API_URL + "/tm/courses/packages";
    const config = {
      headers: {
        Accept: "application/json",
        Authorization: "Bearer " + localStorage.getItem("user_token"),
      },
    };
    try {
      const response = await axios.get(url, config);
      const packages = Array.isArray(response.data)
        ? response.data
        : response.data?.data ?? [];
      commit("SET_PACKAGES", packages);
    } catch (error) {
      console.error(error);
      commit(
        "SET_ERRORS",
        error.response?.data?.message || "Fetch Packages failed"
      );
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
};
